<!--
 * @FileDescription: 设备数据页面
 @time: 2023-9-6
 -->
<template>
  <div class="bg-contain common-blue-contain">
    <div class="breadcrumb-tilte">{{ $t('DataCenter') }} > {{ $t('deviceData') }}</div>
    <div class="common-table-cnt">
      <div class="search search-container">
        <!-- 查询表单 -->
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item :label="$t('mechanism')">
            <el-select
              ref="paramOuSelect"
              v-model="paramOuName"
              style="width:auto"
              :placeholder="$t('peaseSelect')"
              @change="changeParamOu"
              clearable
              @visible-change="visibleChange"

            >
              <el-option :value="paramOuName" style="height:auto;padding:0px">
                <el-tree
                  ref="paramOuTree"
                  node-key="id"
                  default-expand-all
                  highlight-current
                  :expand-on-click-node="false"
                  :data="userData.ouList"
                  :props="defaultProps"
                  @node-click="selectParamOu"
                >
                </el-tree>
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bindUserStatus')">
            <el-select v-model="formInline.binded" clearable :placeholder="$t('bindUserStatus')">
              <el-option :label="$t('bound')" value="1"></el-option>
              <el-option :label="$t('Unbound')" value="0"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('bindPersonnelName')">
            <el-input v-model="formInline.userName" clearable :placeholder="$t('bindPersonnelName')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('serialNumberP2')">
            <el-input v-model="formInline.serialNumber" clearable :placeholder="$t('serialNumberP2')"></el-input>
          </el-form-item>
          <el-form-item :label="$t('deviceType')">
            <el-select v-model="formInline.specType" clearable :placeholder="$t('deviceType')">
              <template v-for="item of helmetType">
                <el-option
                  v-if="checkDeviceType(item.value)"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </template>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('deviceMode')">
            <el-select v-model="formInline.pattern" clearable :placeholder="$t('deviceMode')">
              <el-option v-for="item of modeType" :key="item.value" :label="item.label" :value="item.value"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('presence')">
            <el-select v-model="formInline.onlineStatus" clearable :placeholder="$t('presence')">
              <el-option :label="$t('onLine')" value="1"></el-option>
              <el-option :label="$t('offLine')" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('bindSIMCardStatus')">
            <el-select v-model="formInline.simBinded" clearable :placeholder="$t('bindSIMCardStatus')">
              <el-option :label="$t('bound')" value="1"></el-option>
              <el-option :label="$t('Unbound')" value="0"></el-option>
            </el-select>
          </el-form-item>

          <el-form-item :label="$t('trafficStatisticsTime')" class="datetime">
            <el-date-picker
              v-model="formInline.startTime"
              :placeholder="$t('startDate')"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item :label="$t('TO')" class="totime">
            <el-date-picker
              v-model="formInline.endTime"
              :placeholder="$t('endDate')"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd HH:mm:ss"
              popper-class="date-picker-blue-hw"
              :clearable="true"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="getList" class="serachBtn">{{ $t('query') }}</el-button>
            <el-button type="primary" @click="exportList"  :loading="exportLoading" class="serachBtn">{{ $t('exportButton') }}</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="total-flow">
        <span
          >{{ $t('OnlineEquipmentStatistics') }}：
          <i class="log-num">{{ statisData.sum_online_volume }}</i>
        </span>
        <span
          >{{ $t('offlineDeviceStatistics') }}：
          <i class="log-num">{{ statisData.sum_off_volume }}</i>
        </span>
        <span
          >{{ $t('deviceStatus') }}：
          <i class="log-num">{{ statisData.sum_none_volume }}</i>
        </span>
      </div>
      <div class="table-box">
        <!-- table开始 -->
        <el-table :data="tableData" height="548" style="width: 100%;" @sort-change="sortChange">
          <el-table-column
            type="index"
            :index="indexMethod"
            :label="$t('SerialNo')"
            align="center"
            width="80"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <span>{{ (formInline.pageNum - 1) * formInline.pageSize + scope.$index + 1 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="fullOuName"
            :label="$t('mechanism')"
            width="150"
            sortable="fullOuName"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="userName"
            :label="$t('binder')"
            width="130"
            sortable="userName"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="serialNumber"
            :label="$t('serialNumberP2')"
            width="180"
            sortable="serialNumber"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="specModel"
            :label="$t('specificationModel')"
            width="120"
            sortable="specModel"
            :show-overflow-tooltip="true"
            :sort-orders="['ascending', 'descending']"
          >
          </el-table-column>
          <el-table-column
            prop="specType"
            :label="$t('deviceType')"
            width="120"
            sortable="specType"
            align="center"
            show-overflow-tooltip
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.specType | helmetType }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('state')"
            width="80"
            show-overflow-tooltip
            align="center"
            sortable="onlineStatus"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span :class="scope.row.onlineStatus === 1 ? 'online' : 'offline'">{{
                $t(scope.row.onlineStatus === 1 ? 'onLine' : 'offLine')
              }}</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="simNo"
            :label="$t('cardNumber')"
            width="170"
            show-overflow-tooltip
            align="left"
            sortable="simNo"
            :sort-orders="['ascending', 'descending']"
          ></el-table-column>
          <el-table-column
            prop="volume"
            :label="$t('totalFlow')"
            width="110"
            show-overflow-tooltip
            align="right"
            sortable="volume"
            :sort-orders="['ascending', 'descending']"
          ></el-table-column>
          <el-table-column
            prop="pattern"
            :label="$t('deviceMode')"
            width="130"
            show-overflow-tooltip
            align="center"
            sortable="pattern"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.pattern === 3">{{ $t('privacy') }}</span>
              <span v-if="scope.row.pattern === 2">{{ $t('power') }}</span>
              <span v-if="scope.row.pattern === 1">{{ $t('standard') }}</span>
              <span v-if="scope.row.pattern === 0">{{ $t('performance') }}</span>
            </template>
          </el-table-column>

          <el-table-column
            :label="$t('Power')"
            width="82"
            show-overflow-tooltip
            align="center"
            sortable="battery"
            :sort-orders="['ascending', 'descending']"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.battery">{{ scope.row.battery | toFixed2 }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            prop="offlineTime"
            :label="$t('Offlineduration')"
            width="150"
            sortable="offlineTime"
            align="center"
            :sort-orders="['ascending', 'descending']"
          ></el-table-column>
          <el-table-column
            prop="locationTime"
            :label="$t('positioningTime')"
            width="160"
            align="center"
            sortable="locationTime"
            :sort-orders="['ascending', 'descending']"
          ></el-table-column>
          <el-table-column
            prop="address"
            :label="$t('geographicalPosition')"
            min-width="180"
            align="left"
            show-overflow-tooltip
            sortable="address"
            :sort-orders="['ascending', 'descending']"
          ></el-table-column>
        </el-table>
        <el-pagination
          class="pagination"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="formInline.pageNum"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="formInline.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="totalData"
        >
        </el-pagination>
      </div>
    </div>
  </div>
</template>

<script>
import { downloadBlobExcel } from '@/util/common'
import { HELMET_TYPE } from '@/common/enum'
import { getDeviceData, exportDeviceData } from '@/api/log/status'
import { findStatus } from '@/api/Cockpit'
import { getOus } from '@/api/UserList'
import { mapGetters } from 'vuex'
import { startMonthTime, now } from '@/util/date'
import { SortFun } from '@/util/dataSort'

export default {
  data() {
    return {
      loginIsAdmin: sessionStorage.getItem('isAdmin'),
      // 表单查询参数
      formInline: {
        pageNum: 1,
        pageSize: 10,
        startTime: startMonthTime(),
        endTime: now(),
      },
      // table数据
      tableData: [],
      formLabelWidth: '120px',
      defaultProps: {
        children: 'children',
        label: 'name',
      },
      totalData: 0,
      // 传输设备序列号
      serialNum: '',
      // 设备类型选择查询
      helmetType: HELMET_TYPE,
      exportLoading: false,
      // 这里存放要默认展开的节点 id
      defaultExpandIds: [],
      firstId: '',
      paramOuName: '',
      userData: {
        ouList: [],
        selectList: [],
        id: null,
      },
      modeType: [
        { label: this.$t('performanceMode'), value: 0 },
        { label: this.$t('standardMode'), value: 1 },
        { label: this.$t('powerSavingMode'), value: 2 },
        { label: this.$t('privacyMode'), value: 3 },
      ],
      statisData: { sum_online_volume: 0, sum_off_volume: 0, sum_none_volume: 0 },
    }
  },
  methods: {
    // 点击表头排序
    sortChange({ column, prop, order }) {
      this.formInline.sortColName = !order ? null : column.sortable
      this.formInline.useAsc = order === 'descending' ? 0 : 1
      if (prop === 'locationTime' || prop === 'address') {
        this.tableData = this.tableData.sort(SortFun(prop, order === 'descending'))
      } else {
        this.getList()
      }
    },
    // 查询设备数
    getCountType() {
      let param = { ouId: this.formInline.ouId }
      findStatus(param).then(res => {
        if (res.state === 0) {
          if (res.data && res.data.length !== 0) {
            for (let item of res.data) {
              if (item.status === '1') {
                // 在线设备数
                this.statisData.sum_online_volume = item.number
              } else if (item.status === '0') {
                // 离线设备数
                this.statisData.sum_off_volume = item.number
              } else if (item.status === '2') {
                // 未绑定设备数
                this.statisData.sum_none_volume = item.number
              }
            }
          }
        }
      })
    },
    // 机构查询 滚动条置顶
    visibleChange(val) {
      this.$nextTick(() => {
        let ele = document.querySelector('.el-select-dropdown__wrap')
        ele.scrollTop = ele.scrollHeight
      })
    },
    // 点击查询列表
    getList() {
      this.formInline.pageNum = 1
      this.search()
      this.getCountType()
    },
    // 点击导出列表
    exportList() {
      this.exportLoading = true
      exportDeviceData(this.formInline).then(res => {
        this.exportLoading = false
        downloadBlobExcel(res, this.$t('EquipmentList') + '.xls')
      })
    },
    // 获取列表
    search() {
      getDeviceData(this.formInline).then(res => {
        if (res.state === 0) {
          this.tableData = res.value.list
          this.totalData = res.value.total
        }
      })
    },
    // 获取组织机构
    getOusTree() {
      getOus().then(res => {
        if (res.state === 0) {
          this.userData.ouList = res.data
          if (this.userData.ouList[0] && this.userData.ouList[0].id) {
            this.firstId = this.userData.ouList[0].id
            if (this.defaultExpandIds.indexOf(this.userData.ouList[0].id) === -1) {
              this.defaultExpandIds.push(this.firstId)
            }
          }
        }
      })
    },
    // 选中过滤条件机构，过滤用户
    selectParamOu(data) {
      this.paramOuName = data.name
      this.formInline.ouId = data.id
      this.$refs.paramOuSelect.blur()
    },
    // 清空过滤条件机构，过滤用户
    changeParamOu(data) {
      if (!data) {
        this.formInline.ouId = null
        this.$nextTick(() => {
          this.$refs.paramOuTree.setCurrentKey(null)
        })
      }
    },

    //判断用户是否是超级管理员用户以及非帽衬设备
    powers(row) {
      let powerNet = false
      let loginIsAdmin = sessionStorage.getItem('isAdmin')
      if (loginIsAdmin === '1' && row.specType !== 0) {
        powerNet = true
      }
      return powerNet
    },

    /**
     * 获取头盔规格型号
     */
    getSpecModel() {
      return localStorage.getItem('DEVICE_SPEC_MODEL').split(',')
    },
    handleSizeChange(val) {
      this.formInline.pageSize = val
      this.search()
    },
    handleCurrentChange(val) {
      this.formInline.pageNum = val
      this.search()
    },
    indexMethod(index) {
      return index + 1
    },
    /**
     * 检查头盔类型
     */
    checkDeviceType(specType) {
      return localStorage.getItem('DEVICE_SPEC_TYPE').indexOf(specType + '') === -1 ? false : true
    },
  },
  mounted() {
    this.getOusTree()
    this.search()
    this.getCountType()
  },
  computed: {
    ...mapGetters(['isCloud', 'isOnlySupportIH5']),
  },
}
</script>
<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~@/style/new-set-common.styl'
>>>.el-table
  // height 555px
  // min-height 460px;/* no */
  height 645px!important
  min-height 500px!important;/* no */
  overflow: auto
>>>.el-popper
  width 200px!important/* no */
.el-dialog
  >>>.el-popper
    min-width 315px!important
>>>.el-button+.el-button
  margin-left 10px
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
>>>.el-form-item__label
  min-width 60px;/* no */
  width 151px;/* no */
.totime
  >>>.el-form-item__label
    min-width 20px;/* no */
    width 20px;/* no */
.search
  .demo-form-inline
    overflow: hidden
  .el-form-item:last-child
    div
      margin-left 10px
.total-flow
  margin-bottom 0px
  line-height 36px
  background #f0f9ff
  border: 1px solid var(--border-grey);
  border-bottom: none;
  span
    margin-left 10px
    font-weight: 600
    &:first-child
      margin-left 20px
      .log-num
        color #00cd01
    &:nth-child(2)
      .log-num
        color red
.online
  color #00cd01
.offline
  color red
>>> .el-tree
  height 100%
  background: var(--new-tree-bg)
  color: var(--new-el-select-dropdown-item)
>>>.el-tree-node
  height: 100%
>>>.el-tree-node__content:hover .editBtn
    display inline-block
>>>.el-input__prefix, >>>.el-input__suffix
  color #fff
>>> .el-tree-node__content
  font-weight: 400
  color: var(--new-el-select-dropdown-item)
.el-select-dropdown
  .el-select-dropdown__list
    .el-select-dropdown__item.hover
      background-color var(--new-tree-bg)
.theme-dark
  .search_tree
    .serachBar
      .real-info
        color: #fff
// 深色
.theme-dark
  .total-flow
    background #072368
    border: 1px solid #0057A8;
.bg-contain .common-table-cnt:has(.total-flow) /deep/ .el-table{
  height: 548px !important
}
.common-blue-contain
  .el-pagination
    margin-top 18px
</style>
